/**
 * Support Bus
 * ───────────
 * A tiny window-event bridge so ANY component can pop open the floating
 * <SupportChat /> widget without prop-drilling or shared context.
 *
 *   import { openSupportChat } from '../lib/supportBus';
 *   <button onClick={openSupportChat}>Help</button>
 *
 * <SupportChat /> listens for SUPPORT_OPEN_EVENT and opens itself.
 */

export const SUPPORT_OPEN_EVENT = 'giggs:support:open';

// Dispatch a window event the SupportChat widget is listening for.
export const openSupportChat = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SUPPORT_OPEN_EVENT));
};
